import { Db } from '../types/shared';
import { families } from './families';

// Vzorčno začetno stanje prototipa. Vsi zapisi so vezani na identifikator družine.
export const seedState: Db = {
  families,
  occ: {
    siter: {
      'toffee-hrana-1': { status: 'opravljeno', sync: 'synced', performerId: 'eli' },
      'dihur-hrana-1': { status: 'opravljeno', sync: 'synced', performerId: 'jona' },
      'onyx-hrana-1': { status: 'opravljeno', sync: 'synced', performerId: 'irenej' },
      'milky-stranisce': {
        status: 'odprto',
        sync: 'synced',
        offer: { byId: 'irenej', toId: 'vsi', at: 1791540000000 },
      },
    },
    kovac: {},
  },
  timers: {},
  entries: [
    { id: 'seed-eli-1', familyId: 'siter', memberId: 'eli', date: '2026-10-09', activity: 'Branje', minutes: 18, templateId: 'branje-eli', source: 'casovnik', sync: 'synced' },
    { id: 'seed-eli-2', familyId: 'siter', memberId: 'eli', date: '2026-10-08', activity: 'Branje', minutes: 35, templateId: 'branje-eli', source: 'casovnik', sync: 'synced' },
    { id: 'seed-eli-3', familyId: 'siter', memberId: 'eli', date: '2026-10-07', activity: 'Šport – intenzivna vadba', minutes: 50, templateId: 'sport-eli', source: 'rocno', sync: 'synced' },
    { id: 'seed-eli-4', familyId: 'siter', memberId: 'eli', date: '2026-10-08', activity: 'Risanje', minutes: 40, source: 'casovnik', sync: 'synced', note: 'prosta dejavnost' },
    { id: 'seed-jona-1', familyId: 'siter', memberId: 'jona', date: '2026-10-09', activity: 'Violina – domača vadba', minutes: 10, templateId: 'vadba-violina-jona', source: 'casovnik', sync: 'synced' },
    { id: 'seed-lina-1', familyId: 'kovac', memberId: 'lina', date: '2026-10-09', activity: 'Branje', minutes: 12, templateId: 'branje-lina', source: 'casovnik', sync: 'synced' },
  ],
  schoolPE: {},
  ledger: [
    { id: 'seed-tx-1', familyId: 'siter', memberId: 'eli', amount: 4, reason: 'Branje: dodatnih 30 min', date: '2026-10-07' },
    { id: 'seed-tx-2', familyId: 'siter', memberId: 'eli', amount: 1, reason: 'Urejena soba (torek)', date: '2026-10-06' },
    { id: 'seed-tx-3', familyId: 'siter', memberId: 'eli', amount: 1, reason: 'Urejena soba (sreda)', date: '2026-10-07' },
    { id: 'occ:siter:onyx-hrana-1:2026-10-09:irenej', familyId: 'siter', memberId: 'irenej', amount: 1, reason: 'Onyx – hranjenje zjutraj – skupna skrb', date: '2026-10-09' },
    { id: 'seed-tx-5', familyId: 'siter', memberId: 'jona', amount: 5, reason: 'Violina: prostovoljna vadba na dan pouka', date: '2026-10-06' },
  ],
  rewardRequests: [
    {
      id: 'rr-1',
      familyId: 'siter',
      memberId: 'jona',
      rewardId: 'r-film',
      title: 'Izbira filma na filmskem večeru',
      cost: 30,
      slot: 'Sobota 10. 10., filmski večer',
      status: 'caka',
      createdAt: 1791540000000,
    },
    {
      id: 'rr-2',
      familyId: 'siter',
      memberId: 'eli',
      rewardId: 'r-igra',
      title: 'Izbira naslednje družabne igre',
      cost: 20,
      slot: 'Nedelja 11. 10. popoldne',
      status: 'odobreno',
      createdAt: 1791450000000,
      decidedBy: 'barbara',
    },
  ],
  exceptions: [
    {
      id: 'ex-1',
      familyId: 'siter',
      memberId: 'ema',
      type: 'poseben-vecer',
      from: '2026-10-10',
      to: '2026-10-10',
      note: 'Rojstni dan prijateljice – domov ob 23.00.',
      status: 'caka',
      createdBy: 'ema',
      excuses: ['vecer'],
    },
  ],
  schoolItems: [
    {
      id: 'si-1',
      familyId: 'siter',
      memberId: 'eli',
      kind: 'test',
      title: 'Kemija – test',
      date: '2026-10-13',
      done: false,
      createdBy: 'eli',
      blocks: [
        { id: 'b-1', date: '2026-10-08', minutes: 30, done: true },
        { id: 'b-2', date: '2026-10-09', minutes: 45, done: false },
        { id: 'b-3', date: '2026-10-11', minutes: 30, done: false },
      ],
    },
    { id: 'si-2', familyId: 'siter', memberId: 'irenej', kind: 'domaca', title: 'Matematika – vaje str. 42', date: '2026-10-12', done: false, createdBy: 'irenej', blocks: [] },
    {
      id: 'si-3',
      familyId: 'siter',
      memberId: 'ema',
      kind: 'sprasevanje',
      title: 'Angleščina – besedišče',
      date: '2026-10-14',
      done: false,
      createdBy: 'ema',
      blocks: [{ id: 'b-4', date: '2026-10-09', minutes: 20, done: false }],
    },
    { id: 'si-4', familyId: 'siter', memberId: 'jakob', kind: 'todo', title: 'Zgodovina – referat', date: '2026-10-15', done: false, createdBy: 'jakob', blocks: [] },
    { id: 'si-5', familyId: 'siter', memberId: 'jona', kind: 'todo', title: 'Vrni knjigo v knjižnico', date: '2026-10-09', done: false, createdBy: 'jona', blocks: [] },
    { id: 'si-6', familyId: 'kovac', memberId: 'lina', kind: 'domaca', title: 'Slovenščina – obnova', date: '2026-10-13', done: false, createdBy: 'lina', blocks: [] },
  ],
  shopping: [
    { id: 'sh-1', familyId: 'siter', text: 'Mleko (2 l)', done: false, addedBy: 'barbara' },
    { id: 'sh-2', familyId: 'siter', text: 'Hrana za mačke', done: false, addedBy: 'irenej' },
    { id: 'sh-3', familyId: 'siter', text: 'Seno za kunca', done: true, addedBy: 'jakob' },
    { id: 'sh-4', familyId: 'kovac', text: 'Kruh', done: false, addedBy: 'ana' },
  ],
  polls: [
    {
      id: 'p-1',
      familyId: 'siter',
      title: 'Film za sobotni večer',
      kind: 'film',
      options: [
        { id: 'o-1', label: 'Paddington 2', votes: ['jakob', 'ema'] },
        { id: 'o-2', label: 'Coco', votes: ['barbara'] },
        { id: 'o-3', label: 'Shrek', votes: ['irenej'] },
      ],
      open: true,
      createdBy: 'barbara',
    },
    {
      id: 'p-2',
      familyId: 'siter',
      title: 'Družabna igra v nedeljo',
      kind: 'igra',
      options: [
        { id: 'o-4', label: 'Carcassonne', votes: ['timotej'] },
        { id: 'o-5', label: 'Dixit', votes: [] },
      ],
      open: true,
      createdBy: 'timotej',
    },
  ],
  wishes: [
    { id: 'w-1', familyId: 'siter', title: 'Pohorje z žičnico', note: 'Pozimi ali spomladi', addedBy: 'eli' },
    { id: 'w-2', familyId: 'siter', title: 'Bled s kolesi', link: 'https://www.bled.si', addedBy: 'jakob' },
  ],
  changelog: [],
  weekDraft: {},
  weekCloses: [],
  skippedEvents: [],
  dutyChecks: [
    ...['kuhinja', 'kopalnice', 'hodniki', 'dnevna-soba', 'sesanje', 'perilo', 'okolica', 'soba-teden-eli', 'soba-teden-irenej', 'soba-teden-ema', 'soba-teden-jona', 'soba-teden-jakob'].flatMap(
      (templateId) =>
        (['pon', 'sre'] as const).map((slot) => ({
          familyId: 'siter',
          weekId: '2026-W41',
          templateId,
          slot,
          result: 'urejeno' as const,
          by: slot === 'pon' ? 'barbara' : 'timotej',
          at: slot === 'pon' ? 1791237600000 : 1791410400000,
        }))
    ).filter((c) => !(c.templateId === 'perilo' && c.slot === 'sre') && !(c.templateId === 'kuhinja' && c.slot === 'pon') && !(c.templateId === 'soba-teden-jakob' && c.slot === 'sre')),
    { familyId: 'siter', weekId: '2026-W41', templateId: 'perilo', slot: 'sre', result: 'ni-urejeno', note: 'Suho perilo že dva dni čaka na sušilniku.', by: 'timotej', at: 1791410400000 },
    { familyId: 'siter', weekId: '2026-W41', templateId: 'kuhinja', slot: 'pon', result: 'ni-urejeno', note: 'Pult poln drobtin, pomivalni stroj ni izpraznjen.', fixed: true, by: 'barbara', at: 1791237600000 },
    { familyId: 'siter', weekId: '2026-W41', templateId: 'soba-teden-jakob', slot: 'sre', result: 'ni-urejeno', note: 'Pod posteljo živi nogavica.', by: 'timotej', at: 1791410400000 },
  ],
  dutyReports: [
    { id: 'seed-dr-1', familyId: 'siter', weekId: '2026-W41', templateId: 'kuhinja', memberId: 'jona', date: '2026-10-08', text: 'Izpraznila pomivalni stroj' },
    { id: 'seed-dr-2', familyId: 'siter', weekId: '2026-W41', templateId: 'perilo', memberId: 'eli', date: '2026-10-08', text: 'Oprano' },
  ],
};
